/*
 * Groove overrides that cannot be done in CSS alone.
 *
 * "More payment options" — the PDP has no add-to-cart button (hidden in
 * gd-overrides.css, "only the Buy it now button" — Twan, 2026-08-03), so this
 * link is the only route to a normal checkout. gd-overrides.css turns it into
 * a primary button; here it gets a label that reads like a CTA.
 *
 * textContent, not a CSS ::before trick: font-size:0 + ::before would leave
 * Shopify's wording in the accessible name, so a screen reader would announce
 * both. Same reasoning as the Locksmith login button.
 *
 * Shopify injects the element asynchronously and re-renders it on a variant
 * change, so this observes the DOM instead of running once. Two markup
 * variants exist in the wild: <more-payment-options-link><a> from
 * shopify-accelerated-checkout, and button.shopify-payment-button__more-options
 * from the older shopify-payment-button. Both are covered.
 */
(function () {
  const LABEL = 'I want these sneakers';
  const SELECTOR = 'more-payment-options-link a, .shopify-payment-button__more-options';

  if (!document.body.classList.contains('template-product')) return;

  function relabel() {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      // The guard keeps our own write from re-triggering the observer.
      if (el.textContent.trim() !== LABEL) el.textContent = LABEL;
    });
  }

  relabel();

  new MutationObserver(relabel).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
